import Vue from 'vue'
import Router from 'vue-router'
import AccordionPage from './pages/AccordionPage.vue'
import FrontPage from './pages/Frontpage.vue'
import ButtonsPage from './pages/ButtonsPage.vue'
import AnimateOnScrollPage from './pages/AnimateOnScrollPage.vue'
import RevealOnScrollPage from './pages/RevealOnScrollPage.vue'
import VideoModalPage from './pages/VideoModalPage.vue'
import SmoothScrollPage from './pages/SmoothScrollPage.vue'
import LocomotiveSmoothScrollPage from './pages/LocomotiveSmoothScrollPage.vue'
import FormElementsPage from './pages/FormElementsPage.vue'
import SlidersPage from './pages/SlidersPage.vue'
import DropdownPage from './pages/DropdownPage.vue'
import InputPage from './pages/InputPage.vue'
import BreadcrumbPage from './pages/BreadcrumbPage.vue'
import LoaderPage from './pages/LoaderPage.vue'
import ScrolltopPage from './pages/ScrolltopPage.vue'
import BubblesPage from './pages/BubblesPage.vue'
import CookieBox from './pages/CookieboxPage.vue'
import Graphs from './pages/Graphs.vue'
import ScrollDownPage from './pages/ScrollDownPage.vue'
import SwiperContentSliderPage from './pages/SwiperContentSliderPage.vue'
import CustomSelect from './pages/CustomSelectPage.vue'
import VideoAutoPlayPage from './pages/VideoAutoPlayPage.vue'
import ObjectFitIEFixPage from './pages/ObjectFitIEFixPage.vue'
import FocusTrapPage from "./pages/FocusTrapPage.vue";
import MuraflexPage from './pages/MuraflexPage.vue'


Vue.use(Router)

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'Frontpage',
			component: FrontPage
		},
		{
			path: '/AccordionPage',
			name: 'AccordionPage',
			component: AccordionPage
		},
		{
			path: '/ButtonsPage',
			name: 'ButtonsPage',
			component: ButtonsPage
		},
		{
			path: '/AnimateOnScrollPage',
			name: 'AnimateOnScrollPage',
			component: AnimateOnScrollPage
		},
		{
			path: '/RevealOnScrollPage',
			name: 'RevealOnScrollPage',
			component: RevealOnScrollPage
		},
		{
			path: '/SlidersPage',
			name: 'SlidersPage',
			component: SlidersPage
		},
		{
			path: '/MuraflexPage',
			name: 'Slider1',
			component: MuraflexPage,
		},
		{
			path: '/VideoModalPage',
			name: 'VideoModalPage',
			component: VideoModalPage
		},
		{
			path: '/SmoothScrollPage',
			name: 'SmoothScrollPage',
			component: SmoothScrollPage
		},
		{
			path: '/LocomotiveSmoothScrollPage',
			name: 'LocomotiveSmoothScrollPage',
			component: LocomotiveSmoothScrollPage
		},
		{
			path: '/FormElementsPage',
			name: 'FormElementsPage',
			component: FormElementsPage
		},
		{
			path: '/DropdownPage',
			name: 'DropdownPage',
			component: DropdownPage
		},
		{
			path: '/InputPage',
			name: 'InputPage',
			component: InputPage
		},
		{
			path: '/BreadcrumbPage',
			name: 'BreadcrumbPage',
			component: BreadcrumbPage
		},
		{
			path: '/LoaderPage',
			name: 'LoaderPage',
			component: LoaderPage
		},
		{
			path: '/ScrolltopPage',
			name: 'ScrolltopPage',
			component: ScrolltopPage
		},
		{
			path: '/BubblesPage',
			name: 'BubblesPage',
			component: BubblesPage
		},
		{
			path: '/CookieboxPage',
			name: 'CookieboxPage',
			component: CookieBox
		},
		{
			path: '/ScrolldownPage',
			name: 'ScrolldownPage',
			component: ScrollDownPage
		},
		{
			path: '/SwiperContentSliderPage',
			name: 'SwiperContentSliderPage',
			component: SwiperContentSliderPage
		},
		{
			path: '/Graphs',
			name: 'Graphs',
			component: Graphs
		},
		{
			path: "/CustomSelect",
			name: "CustomSelect",
			component: CustomSelect
		},
		{
			path: "/VideoAutoPlayPage",
			name: "VideoAutoPlayPage",
			component: VideoAutoPlayPage
		},
		{
			path: "/ObjectFitIEFixPage",
			name: "ObjectFitIEFixPage",
			component: ObjectFitIEFixPage
		},
		{
			path: "/FocusTrapPage",
			name: "FocusTrapPage",
			component: FocusTrapPage
		}
	],
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		} else {
			return { x: 0, y: 0 };
		}
	}
});
